import React, { useEffect, useMemo, useState } from 'react';
import { IMedication, ISpecialty } from 'types/operation';
import s from './s.module.less';
import { Button } from 'antd';
import cx from 'classnames';
import { EKlarityPage } from 'types/helloKlarity';

interface IProps {
    previewList?: ISpecialty[];
    type?: EKlarityPage;
}

const MedicationPreview: React.FC<IProps> = ({ previewList, type }) => {
    const [selectedSpecialtyId, setSelectedSpecialtyId] = useState<number>();
    const [previewData, setPreviewData] = useState<ISpecialty[]>([]);

    useEffect(() => {
        if (previewList) {
            setPreviewData(previewList.filter((spec) => spec.medications && spec.medications.length > 0));
        }
    }, [previewList]);

    const selectedSpecialty = useMemo(() => previewData?.find((spec) => spec.id === selectedSpecialtyId), [previewData, selectedSpecialtyId]);

    const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
    };

    useEffect(() => {
        setSelectedSpecialtyId(previewData?.[0]?.id);
    }, [previewData]);

    return (
        <div className={s.previewContainer}>
            {
                type === EKlarityPage.MED_HOME && (
                    <div className={s.header}>
                        <h2 className={s.title}>Find your medications by specialty</h2>
                        <a href="#" className={s.viewAllLink} onClick={handleLinkClick}>
                            View all medications →
                        </a>
                    </div>
                )
            }
            {
                type !== EKlarityPage.MED_HOME && (
                    <div className={s.header}>
                        <h2 className={s.title}>Get a prescription — 500+ options available</h2>
                    </div>
                )
            }

            <div className={s.specialties}>
                {previewData?.sort((a, b) => (a.specialtyPriority || 0) - (b.specialtyPriority || 0)).map((specialty) => (
                    <div
                        key={specialty.id}
                        className={cx(s.specialtyTab, { [s.active]: specialty.id === selectedSpecialtyId })}
                        onClick={() => setSelectedSpecialtyId(specialty.id)}
                    >
                        {specialty.specialtyName}
                    </div>
                ))}
            </div>

            <div className={s.medicationGrid}>
                {selectedSpecialty?.medications?.map((medication: IMedication) => {
                    if (type === EKlarityPage.MED_HOME) {
                        return (
                            <div className={s.medicationCardMedicationHome} key={medication.id}>
                                <div className={s.icon}>
                                    <img className={s.img} src={medication.imageUrl} alt="logo" width={40} height={40} />
                                </div>
                                <div className={s.content}>
                                    <div className={s.title}>{medication.title || '-'}</div>
                                    <div className={s.des}>{medication.subtext || '-'}</div>
                                </div>
                                <div className={s.nav}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                                        <rect width="18" height="18" transform="matrix(0 -1 1 0 0 18.5)" fill="white" />
                                        <path d="M6.75 4.25L12 9.5L6.75 14.75" stroke="#15191E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                            </div>
                        );
                    }
                    return (
                        <div key={medication.id} className={s.medicationCard}>
                            <div className={s.cardContent}>
                                <div>
                                    <h3 className={s.medicationTitle}>{medication.title || '-'}</h3>
                                    <p className={s.medicationSubtext}>{medication.subtext || '-'}</p>
                                </div>
                            </div>
                            <div className={s.imageContainer}>
                                {medication.imageUrl ? <img src={medication.imageUrl} alt={medication.tag} className={s.medicationImage} /> : <div className={s.imagePlaceholder}>-</div>}
                            </div>
                            <Button type="primary" ghost className={s.prescriptionButton}>
                                Get a prescription
                            </Button>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default MedicationPreview;
